module.exports = __webpack_public_path__ + "media/A_level3_loop.603e289e.mp3";